import React from 'react';
import cn from 'classnames';

import styles from './GridBag.module.scss';

const GridBagRulerGridLines = () => (
  <div className={styles.gridLines_container}>
    <div className={styles.gridLines_innerContainerLeft}>
      <div className={styles.gridLines_gridLine} />
    </div>
    <div className={styles.gridLines_innerContainerRight}>
      <div className={styles.gridLines_gridLine} />
    </div>
  </div>
);

type GridBagRulerProps = {
  /** Show helper lines */
  showGridLines?: boolean;
  /** Remove spaces in between columns */
  noGutter?: boolean;
} & JSX.IntrinsicElements['div'];

const GridBagRuler: React.FunctionComponent<GridBagRulerProps> = ({
  showGridLines,
  noGutter,
  ...props
}) => {
  const containerClasses = cn(styles.gridBagRuler_container, {
    [styles.gridBagRuler_noGutter]: noGutter,
  });

  const tableClasses = cn(styles.gridBagRuler_table, {
    [styles.gridBagRuler_noGutter]: noGutter,
  });

  return (
    <div className={containerClasses} {...props}>
      <table className={tableClasses}>
        <tbody style={{ position: 'relative' }}>
          <tr>
            {[...Array(12).keys()].map((column) => {
              return (
                <td
                  key={column}
                  className={styles.gridBagRuler_cell}
                  style={{ position: 'relative' }}
                >
                  {column + 1}
                  {showGridLines && <GridBagRulerGridLines />}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GridBagRuler;
